import { render, staticRenderFns } from "./AddCandidate.vue?vue&type=template&id=5be8984f"
import script from "./AddCandidate.vue?vue&type=script&lang=js"
export * from "./AddCandidate.vue?vue&type=script&lang=js"
import style0 from "./AddCandidate.vue?vue&type=style&index=0&id=5be8984f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports